import { Input } from '@/components/ui/input';
import { Icons } from '@/components/icons';
import { cn } from '@/lib/cn';

type SearchInputProps = React.ComponentProps<'input'> & {
  containerClassName?: string;
};

function SearchInput({
  className,
  containerClassName,
  ...props
}: SearchInputProps) {
  return (
    <div className={cn('relative', containerClassName)}>
      <Input
        type='text'
        className={cn(
          'peer rounded-full ps-9 focus-within:border-input focus-within:ring-0',
          className
        )}
        {...props}
      />
      <div className='pointer-events-none absolute inset-y-0 inset-s-0 flex items-center justify-center ps-3 peer-disabled:opacity-50'>
        <Icons.search
          className='size-4 text-subtle-foreground'
          aria-hidden='true'
        />
      </div>
    </div>
  );
}

export { SearchInput };
